var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length > 0)?_c('Popover',{attrs:{"name":_vm.name}},[_c('div',{staticClass:"vert-scroll popover__list_long"},_vm._l((_vm.list),function(item,index){return _c('p',{key:index},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aab8a64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_shared/components/ui/ItemsPopover.vue
// module id = null
// module chunks = 